<ng-template #appModalTemplate>
    <div class="sil-modal-header" *ngIf="!noHeader">
        <h3 class="sil-modal-title" [innerHTML]="title | punctuationWrap"></h3>
        <button type="button" class="close-modal" aria-label="Close" (click)="closeModal(true)" *ngIf="showCloseIcon">
            <app-icon [icon]="Icon.Close"></app-icon>
        </button>
    </div>
    <div class="sil-modal-body" tracking formname="Smart invest line simulation" stepname="{{adobestepname}}"
        stepoption="{{adobestepclusterOptional}}" submittrigger="button.{{adobeSubmitTiggerClass}}">
        <div class="sil-modal-content">
            <ng-content></ng-content>
        </div>
        <div class="sil-modal-CTA-wrapper col-xs-12" *ngIf="showButton">
            <button [ngClass]="{'btn-primary': isPrimaryButton, 'btn-secondary': !isPrimaryButton}"
                class="btn {{adobeSubmitTiggerClass}}" aria-label="Close" (click)="closeModal()" [innerHTML]="buttonText| punctuationWrap" ></button>
        </div>
        <div *ngIf="showDisclaimer" class="disclaimer-text-under-image" [innerHTML]="disclaimerText| punctuationWrap"></div>
    </div>
</ng-template>